import { CommonApiResponse } from "../Controllers/Types/ApiResponse";
import { ShareContactDetails } from "../Controllers/Types/Project/ShareContactInterface";
import { TenderListInterface } from "../Controllers/Types/Tender/projectTenderDetailsInterface";
import apiClient from "./apiClient";

export const getProjectTenderDetails = async (projectId: number) => {
  try {
    const response = await apiClient.get(
      `/api/project-tender-details/${projectId}`
    );

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const shareContactForSowApi = async (
  project_tender_part_id: number,
  shareContactDetails: ShareContactDetails[]
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      share: shareContactDetails.map((contact) => ({
          by: contact.by,
          id: contact.id,
          can_edit: contact.isCheckedForEdit ? 1 : 0,
          can_view: contact.isCheckedForView ? 1 : 0,
        })),
    };

    

    const response = await apiClient.post(
      `/api/project-tender-part-sow/share`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const shareContactForTenderListAndDocumentApi = async (
  project_tender_part_id: number,
  shareContactDetails: ShareContactDetails[]
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      share: shareContactDetails.map((contact) => ({
          by: contact.by,
          id: contact.id,
          can_edit: contact.isCheckedForEdit ? 1 : 0,
          can_view: contact.isCheckedForView ? 1 : 0,
        })),
    };

    const response = await apiClient.post(
      `/api/project-tender-document/share`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const addTenderDocumentApi = async (
  project_tender_part_id: number,
  document_name: string,
  file: File
): Promise<CommonApiResponse> => {
  try {
    const formData = new FormData();

    // Append form data fields
    formData.append(
      "project_tender_part_id",
      project_tender_part_id.toString()
    );
    formData.append("document_name", document_name);
    formData.append("document", file); // Assuming you have a file input

    const response = await apiClient.postForm(
      `/api/tender-document/create`,
      formData
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const updateTenderDocumentApi = async (
  document_id: number,
  document_name: string,
  file: File
): Promise<CommonApiResponse> => {
  try {
    const formData = new FormData();

    formData.append("document_name", document_name);
    if (file) {
      formData.append("document", file);
    }

    const response = await apiClient.postForm(
      `/api/tender-document/update/${document_id}`,
      formData
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteTenderDocumentApi = async (
  document_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/tender-document/delete/${document_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const getProjectTenderSowTemplate = async () => {
  try {
    const response = await apiClient.get(`/api/project-tender-template`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const useThisTemplateApi = async (
  project_tender_part_id: number,
  template_tender_id: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      template_tender_id: template_tender_id,
    };

    const response = await apiClient.post(
      `/api/project-tender-template-use`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Login failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteSow = async (
  project_tender_part_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/project-schedule-of-work/delete/${project_tender_part_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const getSowSection = async (project_tender_part_id: number) => {
  try {
    const response = await apiClient.get(
      `/api/project-tender-content-section/${project_tender_part_id}`
    );

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const getSowPriliminary = async (project_tender_part_id: number) => {
  try {
    const response = await apiClient.get(
      `/api/project-tender-priliminiery/${project_tender_part_id}`
    );

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//============================================= SOW ================================================================
export const createOrUpdateSowCoverPageDesc = async (
  project_tender_part_id: number,
  text: string
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      text: text,
    };

    const response = await apiClient.post(
      `/api/project-tender/create`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const addSowSection = async (
  project_tender_part_id: number,
  section_name: string,
  after_section_no: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      section_name: section_name,
      after_section_no: after_section_no,
    };

    const response = await apiClient.post(
      `/api/project-tender-content-section/create`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const updateSowSection = async (
  project_tender_part_id: number,
  section_id: number,
  section_name: string,
  after_section_no: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      section_name: section_name,
      after_section_no: after_section_no,
    };

    const response = await apiClient.put(
      `/api/project-tender-content-section/update/${section_id}`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteSowSection = async (
  section_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/project-tender-content-section/delete/${section_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//=========================================================== SUB SECTION ===============================================================
export const addSowSubSection = async (
  section_id: number,
  sub_section_name: string,
  after_sub_section_no: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      section_id: section_id,
      sub_section_name: sub_section_name,
      after_sub_section_no: after_sub_section_no,
    };

    const response = await apiClient.post(
      `/api/project-tender-content-sub-section/create`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const updateSowSubSection = async (
  sub_section_id: number,
  section_id: number,
  sub_section_name: string,
  after_sub_section_no: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      section_id: section_id,
      sub_section_name: sub_section_name,
      after_sub_section_no: after_sub_section_no,
    };

    const response = await apiClient.put(
      `/api/project-tender-content-sub-section/update/${sub_section_id}`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteSowSubSection = async (
  sub_section_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/project-tender-content-sub-section/delete/${sub_section_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//======================================================= ITEM ==========================================================================
export const addSowItem = async (
  item_for: string,
  section_id: number,
  sub_section_id: number,
  item_name: string,
  after_item_no: number
): Promise<CommonApiResponse> => {
  try {
    let credentials = {};

    if (item_for === "Section") {
      credentials = {
        item_for: item_for,
        section_id: section_id,
        item_name: item_name,
        after_item_no: after_item_no,
      };
    } else {
      credentials = {
        item_for: item_for,
        section_id: section_id,
        sub_section_id: sub_section_id,
        item_name: item_name,
        after_item_no: after_item_no,
      };
    }

    const response = await apiClient.post(
      `/api/project-tender-content-item/create`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const updateSowItem = async (
  section_item_id: number,
  item_for: string,
  section_id: number,
  sub_section_id: number,
  item_name: string,
  after_item_no: number
): Promise<CommonApiResponse> => {
  try {
    let credentials = {};

    if (item_for === "Section") {
      credentials = {
        item_for: item_for,
        section_id: section_id,
        item_name: item_name,
        after_item_no: after_item_no,
      };
    } else {
      credentials = {
        item_for: item_for,
        section_id: section_id,
        sub_section_id: sub_section_id,
        item_name: item_name,
        after_item_no: after_item_no,
      };
    }

    const response = await apiClient.put(
      `/api/project-tender-content-item/update/${section_item_id}`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteSowItem = async (
  section_item_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/project-tender-content-item/delete/${section_item_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//=========================================================== Priliminary ==================================================================
export const addSowPriliminary = async (
  project_tender_part_id: number,
  item_name: string,
  after_ref_number: number
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      item_name: item_name,
      after_ref_number: after_ref_number,
    };

    const response = await apiClient.post(
      `/api/project-tender-priliminiery/create`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const updateSowPriliminary = async (
  project_tender_part_id: number,
  priliminary_id: number,
  item_name: string,
  after_ref_number: number
): Promise<CommonApiResponse> => {
  try {
    let credentials = {
      project_tender_part_id: project_tender_part_id,
      item_name: item_name,
      after_ref_number: after_ref_number,
    };

    const response = await apiClient.put(
      `/api/project-tender-priliminiery/update/${priliminary_id}`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const deleteSowPriliminary = async (
  priliminary_id: number
): Promise<CommonApiResponse> => {
  try {
    const response = await apiClient.delete(
      `/api/project-tender-priliminiery/delete/${priliminary_id}`
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//=======================================================
export const getSowFileForDownload = async (project_tender_part_id: number) => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
    };

    const response = await apiClient.post(
      `/api/client-sow-file-download`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, body: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// tender list edit balue by builder data

export const setValueFromTederListEdit = async (
  item_id: number,
  tender_part_share_id: number,
  key_name: string,
  key_value: string
) => {
  try {
    let credentials={};
    if(key_name==="unit_no"){
      credentials = {
        item_id: item_id,
        tender_part_share_id: tender_part_share_id,
        "unit_no": key_value,
      };
    }else if(key_name==="unit_price"){
      credentials = {
        item_id: item_id,
        tender_part_share_id: tender_part_share_id,
        "unit_price": key_value,
      };
    }else if(key_name==="note"){
      credentials = {
        item_id: item_id,
        tender_part_share_id: tender_part_share_id,
        "note": key_value,
      };
    }
    
    const response = await apiClient.post(
      `/api/builder-item-data-add-update`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, body: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }

};


export const setValueFromTederListEditPremi = async (
  priliminiery_id: number,
  tender_part_share_id: number,
  key_name: string,
  key_value: string
) => {
  try {
    let credentials={};
    if(key_name==="unit_no"){
      credentials = {
        priliminiery_id: priliminiery_id,
        tender_part_share_id: tender_part_share_id,
        "unit_no": key_value,
      };
    }else if(key_name==="unit_price"){
      credentials = {
        priliminiery_id: priliminiery_id,
        tender_part_share_id: tender_part_share_id,
        "unit_price": key_value,
      };
    }else if(key_name==="note"){
      credentials = {
        priliminiery_id: priliminiery_id,
        tender_part_share_id: tender_part_share_id,
        "note": key_value,
      };
    }
    
    const response = await apiClient.post(
      `/api/builder-priliminiery-data-add-update`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, body: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }

};


export const tenderlistCompareFromGivenList = async (project_tender_part_id: number, idList:TenderListInterface[] ) => {
  try {
    const credentials = {
      project_tender_part_id: project_tender_part_id,
      comparison:idList
    };
    const response = await apiClient.post(
      `/api/client-comparison`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, body: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};


export const selectedTenderListFixed = async (tender_part_share_id: number ) => {
  try {
    const credentials = {
      tender_part_share_id: tender_part_share_id,
    };
    const response = await apiClient.post(
      `/api/client-fixed-tender-list`,
      credentials
    );

    if (response.status === 200 || response.status === 201) {
      return { status: true, body: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data["message"] };
    } else {
      return { status: false, error: "Failed" };
    }
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};
